/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Summary_TitleInputs */

const en_directory_promotion_summary_title = /** @type {(inputs: Directory_Promotion_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Placement summary`)
};

const zh_directory_promotion_summary_title = /** @type {(inputs: Directory_Promotion_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推广位摘要`)
};

/**
* | output |
* | --- |
* | "Placement summary" |
*
* @param {Directory_Promotion_Summary_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_summary_title = /** @type {((inputs?: Directory_Promotion_Summary_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Summary_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_summary_title(inputs)
	return zh_directory_promotion_summary_title(inputs)
});
export { directory_promotion_summary_title as "directory.promotion.summary_title" }